export function logSearch(query) {
    if (!query || !query.trim()) return;

    const backendUrl = typeof shop_backend_url !== 'undefined' ? shop_backend_url : null;
    const shopId = typeof id_shop !== 'undefined' ? id_shop : null;

    if (!backendUrl || !shopId) return;

    const body = new URLSearchParams({ query: query.trim(), shop_id: String(Number(shopId)) });
    navigator.sendBeacon(`${backendUrl}/api/v1/search/log`, body);
}